import { combineReducers, configureStore } from "@reduxjs/toolkit";
import authReducer, { AuthState } from "./slices/authSlice";
import systemReducer, { SystemState } from "./slices/systemSlice";
import storage from "redux-persist/lib/storage";
import storageSession from "redux-persist/lib/storage/session";
import { persistReducer, persistStore } from "redux-persist";
import autoMergeLevel2 from "redux-persist/lib/stateReconciler/autoMergeLevel2";
import stockReducer, { StockCheckState } from "./slices/stockcheckslice";

const authPersistConfig = {
  key: "auth",
  storage: storageSession,
  stateReconciler: autoMergeLevel2,
};
const systemPersistConfig = {
  key: "system",
  storage,
  stateReconciler: autoMergeLevel2,
};
const stockPersistState = {
  key: "stock",
  storage,
  stateREconciler: autoMergeLevel2,
};
const persistConfig = {
  key: "root",
  storage,
  stateReconciler: autoMergeLevel2,
  blacklist: ["auth"],
};

const rootReducer = combineReducers({
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  auth: persistReducer<AuthState, any>(authPersistConfig, authReducer),
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  system: persistReducer<SystemState, any>(systemPersistConfig, systemReducer),
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  stock: persistReducer<StockCheckState, any>(stockPersistState, stockReducer),
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const persistedReducer = persistReducer<any, any>(persistConfig, rootReducer);

export const store = configureStore({
  reducer: {
    root: persistedReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);
export type RootState = ReturnType<typeof store.getState>;
